export default __webpack_public_path__ + "static/media/MealMarch.a37592b0e55a1d54d38a64abe3e01abe.webp";